import React, { useState, useEffect } from 'react'
import {
  Formik,
  Form,
  useFormikContext,
  Field,
  ErrorMessage,
  setNestedObjectValues,
} from 'formik'
import axios from 'axios'
import { DisplayFormikState } from './helper'

const QuestionSelect = ({ select, name, ...rest }) => {
  return (
    <div className="block m-2 font-xs">
      <div className="inline-block relative w-64">
        <select
          name={name}
          className="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
          {...rest}>
          <option value="">-- Selecciona uno --</option>
          {select.map((option, index) => {
            const { text, value } = option
            return (
              <option key={index} value={value}>
                {text}
              </option>
            )
          })}
        </select>
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
          <svg
            className="fill-current h-4 w-4"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20">
            <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
          </svg>
        </div>
      </div>
    </div>
  )
}

const QuestionChecklist = ({ select, name, ...rest }) => {
  return (
    <div className="grid grid-cols-2 gap-2 max-w-md mx-auto">
      {select.map((option, index) => {
        const { text, value } = option
        console.log('>>>checklist value', value)
        return (
          <label
            key={index}
            className="block appearance-none w-full h-full relative">
            <span className="block appearance-none w-full h-full bg-white border border-gray-400 hover:border-gray-500 px-2 py-2 rounded shadow leading-tight focus:outline-none focus:shadow-outline text-left pr-4">
              {text}
            </span>
            <span className="absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
              <input type="checkbox" value={value} name={`${name}`} {...rest} />
            </span>
          </label>
        )
      })}
    </div>
  )
}

const QuestionOneToTen = ({ name, ...rest }) => {
  const range = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10] //perdón
  return (
    <div>
      <div className="flex align-center justify-between max-w-md mx-auto">
        {range.map((val, index) => {
          return (
            <input
              key={index}
              type="radio"
              value={val}
              name={name}
              className="h-6 w-6"
              {...rest}
            />
          )
        })}
      </div>
      <div className="text flex justify-between max-w-md mx-auto">
        <h4>No</h4>
        <h4>¡Absolutamente!</h4>
      </div>
    </div>
  )
}

const QuestionOpenfield = ({ name, ...rest }) => {
  return (
    <div className="max-w-md mx-auto">
      <textarea
        name={name}
        className="block appearance-none w-full bg-white border border-gray-600 hover:border-gray-500 px-2 py-2 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
        {...rest}
      />
    </div>
  )
}

const QuestionType = ({ type, select, name, ...rest }) => {
  switch (type) {
    case 'select':
      return <QuestionSelect select={select} name={name} {...rest} />
    case 'checklist':
      return <QuestionChecklist select={select} name={name} {...rest} />
    case 'onetoten':
      return <QuestionOneToTen name={name} {...rest} />
    case 'openfield':
      return <QuestionOpenfield name={name} {...rest} />
    default:
      break
  }
  return null
}

const Question = ({
  question,
  onAnswer,
  questionkey,
  isquestionvisible,
  backgroundtype,
}) => {
  const { statement, type, select, id, required } = question
  const [answer, setAnswer] = useState(false)

  const name = `f-${id}-${type}`
  let initialValues = {}

  useEffect(() => {
    console.log('effect!, ', answer)
    if (answer) {
      onAnswer({
        questionkey,
        answer,
      })
    }
  }, [answer])

  if (!isquestionvisible) {
    return null
  }

  return (
    <Formik
      initialValues={initialValues}
      validate={values => {
        const errors = {}
        const keys = Object.keys(values)

        if (!required) {
          return errors
        }

        if (keys.length <= 0) {
          errors.general = 'Requerido'
        } else {
          keys.map(key => {
            console.log('keys.map', key)
            if (!values[key] || values[key].length === 0) {
              errors[key] = 'Requerido'
            }
          })
        }
        return errors
      }}
      onSubmit={(values, { setSubmitting }) => {
        setAnswer(values)
        setSubmitting(false)
      }}>
      {props => {
        const {
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
        } = props
        return (
          <form className="p-2" onSubmit={handleSubmit}>
            {/* <DisplayFormikState {...props} /> */}
            <div className="statement py-2">
              <p dangerouslySetInnerHTML={{ __html: statement }}></p>
            </div>

            <QuestionType
              type={type}
              select={select}
              name={name}
              onChange={handleChange}
              onBlur={handleBlur}
              backgroundtype={backgroundtype}
            />

            <ErrorMessage
              name={name}
              component="div"
              className="red-text-500 text-xs"
            />

            {errors.general && <div>Requerido</div>}
            <div className="submit py-2">
              <button
                type="submit"
                className="inline-block px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-lg text-white bg-rojo-900 hover:bg-red-500 focus:outline-none focus:shadow-outline-rojo focus:border-rojo-900 active:bg-indigo-900 transition duration-150 ease-in-out"
                disabled={isSubmitting}>
                Continuar
              </button>
            </div>
          </form>
        )
      }}
    </Formik>
  )
}

const SurveyQuestions = ({ survey, email, webinar, onEnd, backgroundtype }) => {
  const [actualQuestion, setActualQuestion] = useState(0)
  const [answers, setAnswers] = useState([])
  const [end, setEnd] = useState(false)
  const [showEnd, setShowEnd] = useState(false)
  const totalQuestions = survey.questions.length

  useEffect(() => {
    if (end) {
      axios
        .post('https://strapi.lab.ltnext.com/registerwebinar/survey/', {
          webinar,
          email,
          answers,
        })
        .then(response => {
          console.log(response)
          if (response.status === 200) {
            onEnd(true)
          }
        })
        .catch(err => {
          console.log('>>>err', err.response)
        })
    }
  }, [end])

  return (
    <div>
      <h3 className="text-left max-w-md mx-auto font-bold block leading-tight text-base">
        Pregunta {actualQuestion + 1} de {totalQuestions}:
      </h3>

      {survey.questions.map((question, index) => {
        return (
          <Question
            key={index}
            questionkey={index}
            question={question}
            backgroundtype={backgroundtype}
            isquestionvisible={actualQuestion === index ? true : false}
            onAnswer={({ answer, questionkey }) => {
              setAnswers([...answers, answer])

              if (typeof survey.questions[questionkey + 1] !== 'undefined') {
                setActualQuestion(questionkey + 1)
              } else {
                setEnd(true)
              }
            }}
          />
        )
      })}
    </div>
  )
}

export default SurveyQuestions
